import React from 'react';
import { useLanguage } from '../../i18n/LanguageContext';
import '../static/FellowshipsTable.css';

const ALL_FELLOWSHIP_KEYS = [
  { key: 'mandarinAdultSundaySchool' },
  { key: 'mensGroup' },
  { key: 'sistersTheologyClass', suffix: 'requiresReg' },
  { key: 'qaTheologyDiscussion' },
  { key: 'eveningSing' },
  { key: 'chineseEveningService' },
  { key: 'englishPrayerMeeting' },
  { key: 'familyFellowship', suffix: 'online' },
  { key: 'wednesdayBibleStudy' },
  { key: 'chinesePrayerMeeting' },
  { key: 'elderlyFellowship' },
  { key: 'godkeyFellowship' },
  { key: 'fridayNightFellowship' },
  { key: 'mandarinFellowship' },
  { key: 'cantoneseFellowship' },
  { key: 'practicalTheologyClass' },
];

const AllFellowshipsTable = () => {
  const { t } = useLanguage();

  return (
    <section className="fellowships-section all-fellowships">
      <div className="fellowships-container">
      <div className="fellowships-header">
        <h2 className="siteHeadings">{t('fellowships.heading')}</h2>
      </div>

      {/* Desktop: Table */}
      <div className="table-wrapper">
        <table className="fellowships-table">
          <thead>
            <tr className="table-header-row">
              <th className="table-header fellowship-col">{t('fellowships.colFellowship')}</th>
              <th className="table-header day-time-col">{t('fellowships.colDayTime')}</th>
            </tr>
          </thead>
          <tbody>
            {ALL_FELLOWSHIP_KEYS.map(({ key, suffix }) => (
              <tr key={key} className="table-row">
                <td className="table-cell fellowship-col filled-cell">
                  <strong>{t(`fellowships.entries.${key}.name`)}</strong>
                  {suffix && ` ${t(`fellowships.${suffix}`)}`}
                </td>
                <td className="table-cell day-time-col">{t(`fellowships.entries.${key}.time`)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Mobile: Cards */}
      <div className="fellowships-mobile-cards">
        {ALL_FELLOWSHIP_KEYS.map(({ key, suffix }) => (
          <div key={key} className="fellowship-mobile-card">
            <div className="fellowship-mobile-title">
              {t(`fellowships.entries.${key}.name`)}
              {suffix && ` ${t(`fellowships.${suffix}`)}`}
            </div>
            <div className="fellowship-mobile-details">
              {t(`fellowships.entries.${key}.time`)}
            </div>
          </div>
        ))}
      </div>

      </div>
    </section>
  );
};

export default AllFellowshipsTable;
